import React, { useEffect, useState } from 'react';

import api from '../services/api';

import FormInput from '../FormInput'
import PageSubtitle from '../PageSubtitle'
import ButtonHover from '../ButtonHover'


let buttonStyleTrue = {
  width: '24px',
  height: '24px',
  background: 'green',
  borderRadius: '5px',
  border: 'none',
  padding: '0',
  margin: '2px 10px 0 0',
}

let buttonStyleFalse = {
  width: '24px',
  height: '24px',
  background: 'white',
  borderRadius: '5px',
  border: 'none',
  padding: '0',
  margin: '2px 10px 0 0',
}


export default function PrephysicianEdit (props){

  const[prephysicianId, setPrephysicianId] = useState("")
  const[formalName, setFormalName] = useState("")
  const[stateName, setStateName] = useState("")
  const[institution, setInstitution] = useState("")
  const[available, setAvailable] = useState("")
  const[skills, setSkills] = useState("")
  const[bio, setBio] = useState("")
 

    const updatePrephysician = async(e) => {
      e.preventDefault();
      try {

        await api.put(`prephysician`, {
          prephysicianId, 
          formalName, 
          stateName,
          institution, 
          available,
          skills,
          bio
        });
        // console.log(body);
        window.location = "/home";

      } catch (err) {
        console.error(err.message)
      }
    }


    useEffect(() => {
      props.prephysicianUserData.map(p => {
        if(p.prephysician_id === props.prephysicianModal){
          setPrephysicianId(p.prephysician_id)
          setFormalName(p.formal_name)
          setStateName(p.state_name)
          setInstitution(p.institution)
          setAvailable(p.available)
          setSkills(p.skills)
          setBio(p.bio)
        }
      })
    }, [])
    

    return(
      <div>
        <div style={{display: 'flex'}}>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
          <div style={{width: '86vw'}}>
            <div style={{height: '50px'}}></div>
            <PageSubtitle
              pageSubtitle = 'Cha Cha Change... update your profile'
              />
            <form
              onSubmit={updatePrephysician}
              >
              <FormInput
                autoFocus
                value={formalName}
                onChange={e => setFormalName(e.target.value)}
                placeholder='What is your first name?'
              />
              <FormInput
                value={institution}
                onChange={e => setInstitution(e.target.value)}
                placeholder="What medical school or university do you attend?"
                />
              <FormInput
                value={stateName}
                onChange={e => setStateName(e.target.value)}
                placeholder="What state do you live in?"
                />
              <FormInput
                value={available}
                onChange={e => setAvailable(e.target.value)}
                placeholder='What is your availability (e.g., "3 hours per week")'
                />
              <FormInput
                value={skills}
                onChange={e => setSkills(e.target.value)}
                placeholder='What skills do you have (e.g., "statistics, chart review, excel")'
                />
              <FormInput
                value={bio}
                onChange={e => setBio(e.target.value)}
                placeholder='What do you want your team to know about you?'
                />
              <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '10px 0 0 0'
                }}>
                <div style={{
                    width: '620px',
                    display: 'flex',
                  }}>
                  <div
                    style={props.certification === true
                      ? buttonStyleTrue
                      : buttonStyleFalse
                    }
                    value={props.certification}
                    onClick={props.onButtonClick}
                    name="certification"
                    >
                  </div>
                  <p style={{
                    width:'600px',
                    margin: '0',
                    fontSize: '16px',
                    fontFamily: 'Montserrat',
                    fontWeight: '600',
                    color: '#FFF',
                    }}>
                    I certify that I attend the university or medical school above and that the above information is true. I recognize that this website is in no way responsible for the content I post or any potential HIPPA violations.
                  </p>
                </div>
              </div>
              <div
                style={{
                  margin: '30px 0 150px 0',
                  display: 'flex',
                  justifyContent: 'center'}}
                  >
                <ButtonHover
                  buttonName = "Submit"
                  pageRef = "/home"
                  />
              </div>
            </form>
          </div>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
        </div>
      </div>
    )
  }